import { useState, useEffect } from 'react'
import useApi from 'commons/js/hooks/useApi'

export default function usePaymentProcessor ({
    createSetupIntentCallback,
    handleCardSetupCallback,
    payFineCallback,
}) {
    const [form, setForm] = useState(null)
    const [lastSetupIntent, setLastSetupIntent] = useState(null)
    const {
        response: { result: setupIntent, error: setupIntentError },
        loading: loadingSetupIntent,
        sendRequest: requestSetupIntent,
        resetResponse: resetSetupIntent,
    } = useApi(createSetupIntentCallback)
    const {
        response: { setupIntent: creditCardToken, error: creditCardError },
        loading: loadingCreditCard,
        sendRequest: createCreditCardToken,
        resetResponse: resetCreditCardToken,
    } = useApi(handleCardSetupCallback)
    const {
        response: { result: payment, error: paymentError },
        loading: loadingPayment,
        sendRequest: requestPayFine,
        resetResponse: resetPayment,
    } = useApi(payFineCallback)

    const loading = loadingSetupIntent || loadingCreditCard || loadingPayment
    const error = setupIntentError || paymentError

    useEffect(() => {
        if (!form) {
            return
        }

        resetSetupIntent()
        resetCreditCardToken()
        resetPayment()

        requestSetupIntent()
    }, [form, requestSetupIntent, resetSetupIntent, resetCreditCardToken, resetPayment])

    useEffect(() => {
        if (!setupIntent) {
            return
        }

        createCreditCardToken(setupIntent.clientSecret)
    }, [setupIntent, createCreditCardToken])

    useEffect(() => {
        if (setupIntent === lastSetupIntent || !creditCardToken) {
            return
        }
        setLastSetupIntent(setupIntent)
        requestPayFine({
            setupIntentId: creditCardToken.id,
            firstName: form.firstName,
            lastName: form.lastName,
            email: form.email,
            phone: form.phone,
        })
    }, [creditCardToken, form, requestPayFine, setupIntent, lastSetupIntent, setLastSetupIntent])

    return { payment, loading, error, creditCardError, processPayment: setForm }
}
